<template>
  <v-main>
    <!-- Provides the application the proper gutter -->
    <v-container fluid>
      <v-breadcrumbs :items="breadcrumbs"></v-breadcrumbs>
      <v-card>
        <v-card-title>
          Riwayat Konsultasi Online <br />

          <v-spacer></v-spacer>
          <v-text-field
            v-model="search"
            append-icon="mdi-magnify"
            label="Cari Nama"
            single-line
            hide-details
            @keyup.enter="getDataFromApi"
          ></v-text-field>
          <v-spacer></v-spacer>
        </v-card-title>
        <v-dialog v-model="dialogDelete" max-width="500px">
          <v-card>
            <v-card-title class="text-h5"
              >Apa anda akan menghapus data ini?</v-card-title
            >
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="blue darken-1" text @click="closeDelete"
                >Tidak</v-btn
              >
              <v-btn color="blue darken-1" text @click="deleteItemConfirm"
                >Ya</v-btn
              >
              <v-spacer></v-spacer>
            </v-card-actions>
          </v-card>
        </v-dialog>
        <v-data-table
          v-model="selected"
          :headers="headers"
          :items="list_data"
          :options.sync="options"
          :server-items-length="totalData"
          :loading="loading"
          class="elevation-1"
        >
          <template #[`item.nominal`]="{ item }">
            {{ getIDR(item.nominal) }}
          </template>
          <template #[`item.created_at`]="{ item }">
            {{ getCurrentDate(item.created_at) }}
          </template>
          <template #[`item.tanggal_konsultasi`]="{ item }">
            <span v-if="item.tanggal_konsultasi">
              {{ getCurrentDate(item.tanggal_konsultasi) }} -
              {{ item.jam_konsultasi }}
            </span>
          </template>
          <template #[`item.actions`]="{ item }">
            <v-btn small @click="openDetail(item)"> View </v-btn>
          </template>
        </v-data-table>
      </v-card>

      <!-- Modal -->
    </v-container>
  </v-main>
</template>

<script>
import TelehealthService from "../services/TelehealthService";
import * as moment from "moment";
import CommonService from "../services/CommonService";
import router from "../router";

export default {
  data: () => ({
    breadcrumbs: [
      {
        text: "Riwayat Konsultasi Online",
        disabled: true,
        href: "breadcrumbs_dashboard",
      },
    ],
    childKey: 0,
    search: "",
    selected: [],
    headers: [
      {
        text: "No",
        align: "start",
        sortable: false,
        value: "no",
      },
      { text: "No Invoice", value: "invoice_no", sortable: false },
      { text: "Nama Dokter", value: "nama_dokter", sortable: false },
      { text: "Nama Pasien", value: "nama_pasien", sortable: false },
      { text: "Nominal", value: "nominal", sortable: false },
      { text: "Tanggal", value: "created_at", sortable: false },
      { text: "Status", value: "status_value", sortable: false },
      {
        text: "Tanggal Konsultasi",
        value: "tanggal_konsultasi",
        sortable: false,
      },
      { text: "Jenis", value: "nama_jenis_konsultasi", sortable: false },
      { text: "Actions", value: "actions", sortable: false },
    ],
    isFirst: false,
    totalData: 0,
    list_data: [],
    loading: true,
    options: {
      itemsPerPage: 5,
      page: 1,
    },

    editedIndex: -1,
    editedItem: {},
    dialogDelete: false,
  }),
  computed: {},
  watch: {
    selected: {
      handler() {
        if (this.selected != undefined && this.selected[0]) {
          this.childKey++;
        }
      },
      deep: true,
    },
    options: {
      handler() {
        if (this.isFirst) {
          this.getDataFromApi();
        }
      },
      deep: true,
    },
  },
  mounted() {
    this.getDataFromApi();
  },
  methods: {
    getCurrentDate(tanggal) {
      return moment(tanggal).format("DD/MM/YYYY");
    },
    getIDR(currency) {
      return new Intl.NumberFormat("id-ID", {
        style: "currency",
        currency: "IDR",
        minimumFractionDigits: 0,
      }).format(currency);
    },

    async getDataFromApi() {
      const { page, itemsPerPage } = this.options;

      this.loading = true;
      TelehealthService.historyList(page, itemsPerPage, this.search)
        .then((res) => {
          this.list_data = res.data.list_data;
          this.totalData = res.data.total;
          this.loading = false;
          this.isFirst = true;
        })
        .catch((err) => {
          this.loading = false;
          this.isFirst = true;
          console.log(err);
        });
    },

    openDetail(item) {
      router.push("/history-chats/detail/" + item.id);
    },

    // deleteItem(item) {
    //   console.log(item);
    //   this.editedIndex = this.list_data.indexOf(item);
    //   this.editedItem = Object.assign({}, item);
    //   this.dialogDelete = true;
    // },

    deleteItemConfirm() {
      this.closeDelete();

      TelehealthService.delete(this.editedItem.id)
        .then((res) => {
          console.log(res);
          CommonService.showSuccessToast(
            "Hapus Riwayat Konsultasi Online berhasil",
          );

          this.getDataFromApi();
        })
        .catch((err) => {
          console.log(err);
          CommonService.showErrorToast(
            "Hapus Riwayat Konsultasi Online gagal. Coba lagi",
          );
        });
    },

    closeDelete() {
      this.dialogDelete = false;
      this.$nextTick(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      });
    },
  },
};
</script>
